import { atom, selector } from 'recoil';
import {
  Campaign,
  CampaignShopifyPrePurchasePreviewLinksSelectDto,
  CampaignStatus,
  CampaignTriggerType,
  SubscriptionStatusEnum,
} from '@givz/core-client';
import { CampaignWithReadOnly } from 'src/types';
import { subscriptionState } from '../subscription';

export const campaignsState = atom<Campaign[]>({
  default: [],
  key: 'campaignsState',
});

export const selectedCampaignGidState = atom<string | undefined>({
  default: undefined,
  key: 'selectedCampaignGidState',
});

export const selectedCampaignSelector = selector<
  CampaignWithReadOnly | undefined
>({
  get: ({ get }) => {
    const campaigns = get(campaignsState);
    const selectedCampaignGid = get(selectedCampaignGidState);
    const subscription = get(subscriptionState);

    let selectedCampaign: CampaignWithReadOnly | undefined = selectedCampaignGid
      ? campaigns.find((campaign) => campaign.gid === selectedCampaignGid)
      : undefined;

    if (selectedCampaign) {
      selectedCampaign = {
        ...selectedCampaign,
        readOnly:
          selectedCampaign.status === CampaignStatus.Archived ||
          subscription?.status !== SubscriptionStatusEnum.Active,
      };
    }

    return selectedCampaign;
  },
  key: 'selectedCampaignSelector',
});

export const selectedCampaignIsUsingMinPurchaseTriggerSelector =
  selector<boolean>({
    get: ({ get }) => {
      const selectedCampaign = get(selectedCampaignSelector);

      return selectedCampaign?.trigger.type === CampaignTriggerType.MinPurchase;
    },
    key: 'selectedCampaignIsUsingMinPurchaseTriggerSelector',
  });

export const prePurchasePreviewLinksState =
  atom<CampaignShopifyPrePurchasePreviewLinksSelectDto>({
    default: {},
    key: 'prePurchasePreviewLinksState',
  });
